import { atom } from "recoil";

// 主拆分金额
export const languageAtom = atom<"en" | "zh">({
  key: "language",
  default: (localStorage.getItem("language") as "en" | "zh") || "zh",
});
